import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AuthErrorResponse {
  @jsonMember readonly message!: string;
}
